import React from 'react';
import PropTypes from 'prop-types';
import ChallengeRow from '../ChallengeRow';
import { noop } from '../propTypes';
import challengePropType from '../ChallengeRow/propTypes';
function ChallengesList({ challenges, onActiveToggle }) {
    const list =
        challenges &&
        challenges.map(
            (
                {
                    id,
                    name,
                    description,
                    thumbnail,
                    progress,
                    pickups,
                    target,
                    startDate,
                    endDate,
                    isActive,
                    isMember,
                    type,
                },
                index,
            ) => {
                return (
                    <li key={id}>
                        <ChallengeRow
                            id={id}
                            name={name}
                            description={description}
                            badge={type}
                            thumbnail={thumbnail}
                            progress={progress}
                            pickups={pickups}
                            target={target}
                            isMember={isMember}
                            startDate={startDate}
                            endDate={endDate}
                            toggleState={isActive}
                            onToggle={() => {
                                onActiveToggle(index);
                            }}
                        />
                    </li>
                );
            },
        );

    return <div>{list}</div>;
}

ChallengesList.propTypes = {
    // challenges array to be displayed inside list
    challenges: PropTypes.arrayOf(
        PropTypes.shape({
            ...challengePropType,
            isGlobal: PropTypes.bool,
            isConnected: PropTypes.bool,
            isActive: PropTypes.bool,
            isMember: PropTypes.bool,
        }),
    ),
    // function called when the switch button is toggled
    onActiveToggle: PropTypes.func,
};

ChallengesList.defaultProps = {
    challenges: [],
    onActiveToggle: noop,
};

export default ChallengesList;
